module.exports = __webpack_public_path__ + "media/images/vector99-125150c095a65d97c190f9c8e0578469.svg";